import type { IContainer } from '@monofe/di';
import { buildBindable } from '@monofe/di';
import {
    injectConfigCache,
    injectFetch,
    injectLog,
    injectProgressPromise,
    TYPES as UTIL_TYPES,
} from '@monofe/util';
import {
    injectMessageInstantiator,
    TYPES as MESSAGE_TYPES,
} from '../../message/interface/instantiator';
import { injectChannelController, TYPES as WORKER_TYPES } from '../../util/interface';
import { injectRegexSerializer } from '../../util/interface/regex';
import type { IServiceWorkerController } from '../interface/controller';
import {
    bindServiceWorkerController,
    injectServiceWorkerController,
    TYPES,
    unbindServiceWorkerController,
} from '../interface/controller';
import controller from './controller';

function _build(container: IContainer): Promise<Readonly<IServiceWorkerController>> {
    const deps = {
        log: injectLog(container),
        fetcher: injectFetch(container),
        promiser: injectProgressPromise(container),
        config: injectConfigCache(container),
        regexParser: injectRegexSerializer(container),
        message: injectMessageInstantiator(container),
        channelController: injectChannelController(container),
    };

    return Object.freeze(controller(deps));
}

export default buildBindable<IServiceWorkerController>({
    id: TYPES.IServiceWorkerController,
    dependencies: [
        UTIL_TYPES.ILog,
        UTIL_TYPES.IFetch,
        UTIL_TYPES.IProgressPromiseGenerator,
        UTIL_TYPES.IConfigCache,
        WORKER_TYPES.IRegexSerializer,
        MESSAGE_TYPES.IMessageInstantiator,
        WORKER_TYPES.IChannelController,
    ],
    bind: bindServiceWorkerController,
    remove: unbindServiceWorkerController,
    inject: injectServiceWorkerController,
    build: container => _build(container),
});
